import * as React from 'react';

import { EstimateItem } from 'src/api';
import { EstimateDescription } from './desktop/estimate-description';
import { ViewMore } from 'src/core/components/view-more';

interface Props {
    item: EstimateItem;
}

export const EstimateDescriptionContainer: React.SFC<Props> = ({ item }) => (
    <ViewMore dangerouslySetInnerHTML={item.descriptionSanitized} component={EstimateDescription} />
);
